export default __webpack_public_path__ + "static/media/cubeloader.c87f7e17.svg";